//=====================================
//jquery
// import $ from 'jquery';
// window.$ = $;
// window.jQuery = $;
//=====================================
// window.$ = window.jQuery = require('jquery');
// global.$ = global.jQuery = require('jquery');
window.App = window.App  || {};

//=====================================
//Bootstrap
import * as bootstrap from 'bootstrap';
// Or import only needed plugins
import { Tooltip as Tooltip, Toast as Toast, Popover as Popover } from 'bootstrap';
// Or import just one
// import Alert as Alert from '../node_modules/bootstrap/js/dist/alert';
//=====================================
require('bootstrap');
//=====================================
//Gsap
//=====================================
//=====================================
//SplitType
//=====================================
const SplitType = require('split-type').default;
window.SplitType = SplitType;
//=====================================
//Swiper
// import Swiper JS
// Swiper, Keyboard, Navigation, Pagination, Controller, History, Autoplay, EffectFade, EffectCube, EffectFlip, EffectCoverflow, Lazy, A11y
//=====================================
// const Swiper = require('swiper/bundle').default;
// const { Navigation, Pagination, Autoplay, EffectFade } = Swiper;
// Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);
// window.Swiper = Swiper;


$(function(){
/////////////////////////////////
// scrolled
/////////////////////////////////
  const header = $('#glb-header');
  const headerHeight = header.outerHeight(); // 高さを取得
  $(window).on('scroll', function() {
    if ($(this).scrollTop() >= headerHeight) {
      $('body').addClass('is_scroll');
    } else {
      $('body').removeClass('is_scroll');
    }
  });

/////////////////////////////////////////////
//MARQUEE #TEST 
/////////////////////////////////////////////
class Marquee {
  constructor() {
    this.els = document.querySelectorAll('.marquee');
    console.log(this.els);
    if (!this.els) return;
    this.init()
  }
  init() {
    this.els.forEach(el => {
      // 要素が非表示の場合は処理をスキップ
      if (getComputedStyle(el).display === 'none') return;

      const options = {
        speed: el.dataset.marqueeSpeed || 60,
        direction: el.dataset.marqueeDirection || 'left',
        pauseOnHover: el.dataset.marqueeHover === 'true'
      };
      this.Marquee(el, options);
    })
  }
  Marquee(el, options) {
    const { speed, direction, pauseOnHover } = options;
    const wrapper = el.querySelector('.marquee-wrapper');
    const content = el.querySelector('.marquee-content');
    this.appendContent(content, wrapper);
    this.updateWrapperWidth(content, wrapper);
    const animation = this.Animation(wrapper, speed, direction);

    this.hoverEvent(el, animation, pauseOnHover);
    this.observerEvent(el, animation);
  }
  updateWrapperWidth(content, wrap) {
    const contentWidth = content.getBoundingClientRect().width;
    console.log(contentWidth);
    if (contentWidth === 0) return;
    const gap = parseInt(getComputedStyle(content).columnGap);
    wrap.style.width = `${contentWidth + gap}px`;
  }
  appendClone(content, wrap) {
    const clone = content.cloneNode(true);
    wrap.appendChild(clone);
  }
  appendContent(content, wrap) {
    const innerWidth = window.innerWidth;
    const contentWidth = content.getBoundingClientRect().width;

    this.appendClone(content, wrap);

    if (contentWidth < innerWidth) {
      const numClones = Math.ceil(innerWidth / contentWidth);
      for (let i = 0; i < numClones; i++) {
        this.appendClone(content, wrap);
      }
    }
  }
  Animation(wrap, speed, direction) {
    const wrapWidth = wrap.getBoundingClientRect().width;

    if (wrapWidth === 0) return;
    const keyframes = direction === 'left' ?
      [{ translate: '0 0' }, { translate: '-100% 0' }] :
      [{ translate: '-100% 0' }, { translate: '0 0' }];
    const options = {
      duration: (wrapWidth / speed) * 1000,
      iterations: Infinity,
    }
    return wrap.animate(keyframes, options);
  }
  hoverEvent(el, animation, hasOpt) {
    if (!hasOpt) return;
    el.addEventListener('mouseenter', () => animation.pause());
    el.addEventListener('mouseleave', () => animation.play());
  }
  observerEvent(el, animation) {
    const observerOptions = {
      root: null,
      threshold: 0,
    };

    const observer = new IntersectionObserver((entry) => {
      entry[0].isIntersecting ? animation.play() : animation.pause();
    }, observerOptions);

    observer.observe(el);
  }
}
const marquee = new Marquee();
});